import { InvestmentsState } from './types'

const initialState: InvestmentsState = {
  tutorialCompleted: null,
  isLoading: false,
  isError: false,
  isBalanceHoldingError: false,
  investedBalance: 0,
  performance: {},
  investmentClient: undefined,
  investmentClientLoading: false,
  balanceHoldingAccount: '0',
  loadingHoldingAccount: false,
  lastPerformance: 0,
  authorization: null,
  orders: [],
  investmentHours: {
    subscription: [],
    rescue: []
  },
  fund: undefined,
  investmentHolidays: [],
  selected: undefined,
  isParamsLoading: false,
  isTutorialLoading: false
}

export default initialState
